import config from "../config/config";
import { getToken } from "../utils/prefix";

export async function user_login(data) {
  const res = await fetch(config.api_backend + `/user/login`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function user_create_login(data) {
  const res = await fetch(config.api_backend + `/user/update/status`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function user_create(data) {
  const res = await fetch(config.api_backend + `/user/register`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function admin_user_create(data) {
  const res = await fetch(config.api_backend + `/user/create`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function user_update(data) {
  const res = await fetch(config.api_backend + `/user/update`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function user_delete(data) {
  const res = await fetch(config.api_backend + `/user/delete`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_user(data) {
  const res = await fetch(config.api_backend + `/user/getUserById`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_all_user(data) {
  const res = await fetch(config.api_backend + `/user/all`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_all_org_user(data) {
  const res = await fetch(config.api_backend + `/user/all_org`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function save_user_status(data) {
  const res = await fetch(config.api_backend + `/user/saveUserStatus`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_profile() {
  try {
    const res = await fetch(config.api_backend + `/user/profile`, {
      body: JSON.stringify(),
      method: "POST",
      headers: {
        "x-access-token": getToken(),
        "Content-type": "application/json",
      },
    });
    const dataRespone = await res.json();
    return dataRespone;
  } catch (e) {
    console.error(e);
  }
}

export async function edit_profile(data) {
  const res = await fetch(config.api_backend + `/user/edit`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });
  const dataRespone = await res.json();
  return dataRespone;
}

export async function upload_profilepic(formData) {
  const res = await fetch(config.api_backend + `/user/uploadprofile`, {
    body: formData,
    method: "POST",
    headers: {
      "x-access-token": getToken(),
    },
  });
  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_role() {
  const res = await fetch(config.api_backend + `/user/role`, {
    body: JSON.stringify(),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });
  const dataRespone = await res.json();
  return dataRespone;
}

export async function api_forgotPassword(data) {
  const res = await fetch(config.api_backend + `/user/forgotpass`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
  });
  const dataRespone = await res.json();
  return dataRespone;
}

export async function api_confirmNewPassword(data) {
  const res = await fetch(config.api_backend + `/user/updatepassword`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
  });
  const dataRespone = await res.json();
  return dataRespone;
}

export async function api_optionsUser(data) {
  const res = await fetch(config.api_backend + `/user/optionsuser`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
  });
  const dataRespone = await res.json();
  return dataRespone;
}

export async function export_user(data) {
  const res = await fetch(config.api_backend + `/user/exportuser`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });
  const blob = await res.blob();
  return blob;
}
